<template>
  <BannerController
    v-if="isProviderOrg
      && !!totalCountOfAllItems"
    :bannerContent="bannerContent"
    :data-test-id="$testId('Banner')"
  >
    <div
      :class="$style.content"
    >
      <div :class="$style.text">
        <div
          :data-test-id="$testId('LicensesAvailableText')"
        >
          <Icon
            v-if="statusType === 'error'"
            :class="$style.errorIcon"
            :data-test-id="$testId('errorIcon')"
            icon="info"
            :inline="true"
            :scale="1.0"
          />
          <Icon
            v-else-if="statusType === 'warning'"
            :class="!altLicenseText ? $style.warningIcon : $style.warningIconAlt"
            :data-test-id="$testId('warningIcon')"
            icon="info"
            :inline="true"
            :scale="1.0"
          />
          <Icon
            v-else-if="statusType === 'informational'"
            :class="$style.informationalIcon"
            :data-test-id="$testId('infoIcon')"
            icon="info"
            :inline="true"
            :scale="1.0"
          />
          <strong>
            {{ licensesAvailable }} User {{ licensesAvailableText }} Available
          </strong>
        </div>
        <div
          :data-test-id="$testId('AdditionalLicenseText')"
        >
          {{ additionalLicensesText }}
        </div>
      </div>
    </div>
  </BannerController>
</template>

<script>
import { Icon } from '@jumpcloud/ui-components';
import {
  ItemTypeConsts,
  StoreModuleMap,
} from 'client/util/Constants';
import { mapGetters, mapState } from 'vuex';
import BannerController from 'client/components/ViewportBanner/BannerController.vue';
import BannerType from 'client/components/ViewportBanner/BannerType';

const settingsModule = StoreModuleMap[ItemTypeConsts.settings];
const organizationsCollection = StoreModuleMap[ItemTypeConsts.organizations];

export default {
  name: 'UserCapBanner',

  components: {
    BannerController,
    Icon,
  },
  props: {
    altLicenseText: {
      type: Boolean,
      default: false,
    },
    totalCountOfAllItems: {
      type: Number,
      default: 0,
    },
  },

  computed: {
    ...mapGetters(settingsModule, ['isProviderOrg']),

    ...mapState(settingsModule, [
      'isCustomer',
      'maxSystemUsers',
    ]),
    ...mapGetters(organizationsCollection, {
      getOrganizationDetails: 'getItemDetails',
    }),

    additionalLicensesText() {
      let licenseText = '';

      if (!this.altLicenseText) {
        licenseText = `You have used ${this.totalCountOfAllItems} out of ${this.maxSystemUsers} licenses.
        Please contact your service provider to add more.`;
      } else {
        licenseText = `You have used ${this.totalCountOfAllItems} out of ${this.maxSystemUsers} allowed licenses. Continuing with this import may put you over your limit. A maximum of ${this.maxSystemUsers} users will be imported and the rest will fail.
        To add more licenses, please contact your MSP admin.`;
      }

      return licenseText;
    },

    bannerContent() {
      return new BannerType({
        bannerVisibility: () => !!this.maxSystemUsers
        && this.isProviderOrg,
        bannerType: this.statusType,
        canCloseBanner: false,
        name: 'UserCapBanner',
      });
    },

    licensesAvailable() {
      return this.totalCountOfAllItems > this.maxSystemUsers ? 0
        : this.maxSystemUsers - this.totalCountOfAllItems;
    },
    licensesAvailableText() {
      return this.maxSystemUsers - this.totalCountOfAllItems === 1 ? 'License' : 'Licenses';
    },
    statusType() {
      if (this.totalCountOfAllItems >= this.maxSystemUsers) {
        return 'error';
      }
      if (this.totalCountOfAllItems >= this.maxSystemUsers - 10) {
        return 'warning';
      }
      return 'informational';
    },
  },
};
</script>

<style module>
.content {
  align-items: flex-start;
  display: inline-block;
  gap: var(--jc-spacer);
  grid-template-columns: 1fr auto;
  text-align: left;
}

.errorIcon {
  color: var(--jcError300);
}

.warningIcon {
  color: var(--jcWarning300);
}

.warningIconAlt {
  color: var(--jcInformationalBase);
}

.informationalIcon {
  color: var(--jcSuccess300);
}
</style>
